export default {
    'AUTH.LOG_OUT.TITLE': 'Se déconnecter de Calizy Pro',
    'AUTH.LOG_OUT.ASIDE': 'Voulez-vous vraiment vous déconnecter ?',
    'AUTH.LOG_OUT.NOT.ACTIVE': 'Si vous vous déconnectez sans avoir créé de mot de passe, vous ne pourrez plus vous connecter avec cette adresse email',
    'AUTH.LOG_OUT.NO': 'Non',
    'AUTH.LOG_OUT.YES': 'Oui',
};
